import React from "react";

const MainpageLoader = () => {
  return <div className="screen-loading">
    <div class="progress-loading indeterminate"></div>
  </div>;
};

export default MainpageLoader;
